<template>
	<Modals
		:title="`${integratorName} - Dependent 3P Vendors`"
		:validateBeforeClose="validateBeforeClose"
		:display="display"
		@show="close"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		:fullMobile="true"
	>
		<template #modal-content>
			<div class="dependent-vendor-modal">
				<div class="results-toolbar results-toolbar--variant-one">
					<div class="results-toolbar__search">
						<Search
							variant="toggle-icons"
							:placeholder="placeholder"
							v-model.lazy="search"
							data-test="search"
						/>
					</div>
					<div
						class="results-toolbar__counter"
						v-if="!loading"
						data-test="counter"
					>
						<ResultCounter :counter="vendorsData.length" />
					</div>
				</div>
				<DependentVendorsList
					v-if="vendorsData.length && !loading"
					class="vendor-search__results"
					:vendors="vendorsData"
					data-test="list"
				/>
				<Spinner
					:processor="{ loading: loading }"
					data-test="spinner"
				/>
				<NoResults
					v-if="!vendorsData.length && !loading"
					data-test="noResults"
				/>
			</div>
		</template>
		<template #modal-footer>
			<Button
				className="btn--primary"
				labelText="Close"
				:btnClick="close"
			/>
		</template>
	</Modals>
</template>

<script>
import Button from '@/components/forms/button/button';
import DependentVendorsList from './dependent-vendors-modal-list';
import Modals from '@/components/shells/modal/modals';
import Search from '@/components/forms/search/search';
import ResultCounter from '@/site-components/result-counter/result-counter';
import NoResults from '@/site-components/no-results/no-results';
import Spinner from '@/components/visual/spinner/spinner';
import { filterAndSortArray } from '@/utils/function';
import { mapActions } from 'vuex';
import { MODULE_NAME, DEPENDENTS_VENDOR } from '../vendors-mutation-types';

export default {
	name: 'DependentVendorsModal',
	components: {
		Button,
		DependentVendorsList,
		Modals,
		Search,
		ResultCounter,
		Spinner,
		NoResults
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: 'Search 3P Vendors'
		},
		parentTag: {
			type: String,
			default: 'div'
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		display: {
			type: Boolean,
			default: false
		},
		integratorId: {
			type: Number
		},
		integratorName: {
			type: String
		}
	},
	data() {
		return {
			privilegedUser: true,
			search: '',
			vendorsData: [],
			loading: false
		};
	},
	methods: {
		...mapActions(MODULE_NAME, ['setDependentsVendor']),
		close() {
			this.$emit('close', false);
		},
		filterFormBySearch(val) {
			let result = filterAndSortArray(
				this.vendorsData,
				{
					integratorName: val.toLowerCase()
				},
				null
			);

			this.vendorsData = [...result];
			this.loading = false;
		},
		async fetchData() {
			this.loading = true;
			let query = Object.assign(
				{},
				{ integratorId: this.integratorId, search: this.search }
			);

			await this.setDependentsVendor(query).finally(() => {
				this.loading = false;
			});

			this.vendorsData = this.$store.state.integrators[
				DEPENDENTS_VENDOR
			].items;
		}
	},
	watch: {
		display(val) {
			if (val) {
				this.fetchData();
			}
		},
		search(val) {
			this.loading = true;

			if (val) {
				this.filterFormBySearch(val);
			} else {
				this.vendorsData = this.$store.state.integrators[
					DEPENDENTS_VENDOR
				].items;
				this.loading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * 3P Vendor Manager - Vendor card - Dependent 3P Vendors Modal
    * Can use SCSS variables = TRUE
*/

::v-deep .modal {
	@include mq($from: md) {
		width: 390px;
	}
}

::v-deep .modal__body {
	overflow: initial;
}

::v-deep
	.results-toolbar.results-toolbar--variant-one
	.results-toolbar__search {
	@include mq($from: md) {
		width: 100%;
	}
}

.dependent-vendor-modal {
	padding-bottom: $padding-md;
}
</style>
